import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-cefloreco-mobile-app.js';

const html = `
<div
  data-use-custom-width="true"
  data-custom-width="1204"
  class="container"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="layout-section" data-attribute="layout-section">
    <div class="title-card" data-attribute="title-card">
      <p style="color: #ff7657; text-align: center;">Made for every day</p>
      <h2 style="text-align: center">
        Small screens. <br />
        Rich experiences.
      </h2>
      <p style="text-align: center">
        Clear, responsive and carefully paced—our mobile experiences are designed to feel natural from the very first
        tap.
      </p>
    </div>
    <div class="wrap-image">
      <img
        data-attribute="image"
        src="https://cdn.skyfastimg.com/images/2026/10/27/image-6ae026c1831cb0958f79270a.webp?w=1000&q=100"
        alt=""
      />
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#000',
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/10/27/image-6ae02b28318f09673cacf2a0.webp?w=1000&q=100',
  textColor: '#fff',
  topPadding: true,
  bottomPadding: false,
});
